import React from "react";
import { useSelector } from "react-redux";
import { Drawer } from "antd";
import Button from "@dtci/spellbook/Button";
import Select from "@dtci/spellbook/Select";
import { ViewRateCardForm } from "./view-form";
import { useRateCardsActions } from "tap/store/rateCards/useRateCards.js";
import "./styles.scss";

export const ViewRateCardDrawer = () => {
  const { isViewRateCardDrawerOpen, rateCardHistory, selectedHistory } =
    useSelector((state) => state.rateCards);
  const { updateRateCards } = useRateCardsActions();

  const handleClose = () => {
    updateRateCards({
      isViewRateCardDrawerOpen: false,
    });
  };

  // Data reset deferred to afterOpenChange to allow close animation to complete
  const handleAfterOpenChange = (open) => {
    if (open) return;
    updateRateCards({
      selectedRateCard: {},
      rateCardHistory: [],
      selectedHistory: "",
    });
  };

  const drawerHeader = (
    <div className="view-rate-card-drawer-header">
      <span className="view-rate-card-drawer-title">Rate Card View</span>
      <div className="view-rate-card-drawer-actions">
        <Select
          placeholder="History"
          options={rateCardHistory}
          isClearable
          isSearchable
          onChange={(value) => updateRateCards({ selectedHistory: value })}
          value={selectedHistory}
        />
      </div>
    </div>
  );

  const drawerWidth = selectedHistory ? 1000 : 750;

  return (
    <Drawer
      className="create-drawer"
      title={drawerHeader}
      width={drawerWidth}
      placement="right"
      open={isViewRateCardDrawerOpen}
      onClose={handleClose}
      afterOpenChange={handleAfterOpenChange}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div className="view-rate-card-drawer-footer">
          <Button
            iconType="fa-solid fa-xmark"
            labelText="close"
            styleType="link"
            onClick={handleClose}
          >
            Close
          </Button>
        </div>
      }
    >
      <ViewRateCardForm />
    </Drawer>
  );
};
